<template>
  <div class="counter-divs cf">
    <div class="counter">
      <div>
        <p>
          Vrijeme za odgovor: <br>
          <span class="af">{{ values.leftValue }}</span> <span>{{ values.rightValue }}</span><br>
          <small>{{ values.leftDesc }}</small> <small>{{ values.rightDesc }}</small>
        </p>
      </div>
    </div>
    <div class="score">
      <div class="cf">
        Pitanje:
        <span> {{ questionNumber }} <small>od {{ totalQuesitons }}</small></span>
      </div>
    </div>
  </div>
</template>

<script>
import { TimeUtils, DDHHMMSSCounterValues } from '../utils/timeUtils'
import { QuestionUtils } from '../utils/questionUtils'
export default {
    name: 'pitanje-counter',
    computed: {
        questionNumber () {
            let keys = Object.keys(this.round.questions)
            let i = keys.findIndex(key => this.questionId === key) + 1
            return i
        },
        totalQuesitons () {
            let keys = Object.keys(this.round.questions)
            return keys.length
        },
        questionId () {
            return this.$route.params.id
        },
        question () {
            return this.round.questions[this.questionId]
        },
        counters () {
            return this.$store.state.counters
        },
        values () {
            let questionTimeUntilEnd = QuestionUtils.questionTimeUntilEnd(this.round, this.questionId)
            let timeLeft = this.counters.seconds - questionTimeUntilEnd
            if (timeLeft > 0) {
                let timeObject = TimeUtils.secondsToTimeObject(timeLeft)
                return DDHHMMSSCounterValues(timeObject)
            } else {
                return DDHHMMSSCounterValues(TimeUtils.secondsToTimeObject(0))
            }
        },
        round () {
            return this.$store.getters.round
        }
    }
}
</script>

<style lang="scss" scoped>
.counter-divs {
    font-family: "mPlus";
    text-align: left;
    margin-left: -24px;
    font-size: 14px;
    letter-spacing: -.2px;
    display: flex;

    > div {
        width: 50%;
        float: left;
        padding-left: 24px;
    }
    .counter {
        div {
            box-shadow: 0px 18px 24px 0px rgba(0,0,0,0.34);
            padding: 16px 14px 14px;
            background-color: #001840;
            color: #fff;
            border-radius: 10px;
            height: 100%;
        }
        p {
            margin: 0;
            white-space: nowrap;

            span {
                font-size: 25px;
                display: inline-block;
                margin: 5px 0 2px;
                min-width: 46px;
            }
            span.af:after {
                content: ':';
            }
            small {
                font-family: "axiforma";
                display: inline-block;
                text-transform: uppercase;
                font-size: 10px;
                letter-spacing: 1px;
                color: #85c0f8;
                min-width: 46px;
            }
        }
    }
    .score {
        div {
            box-shadow: 0px 18px 24px 0px rgba(0,0,0,0.34);
            padding: 16px 14px 14px;
            background-color: #fff;
            color: #000;
            border-radius: 10px;
            height: 100%;

            span {
                display: block;
                font-family: "mPlus";
                font-size: 40px;
                letter-spacing: -.2px;
                margin-top: 6px;
            }
            small {
                font-size: 17px;
                color: #3d85ce;
                margin-left: -6px;
            }
        }
    }
}
@media only screen and (max-width: 380px) {
    .counter-divs {
        font-size: 13px;
    }
}
@media only screen and (max-width: 360px) {
    .counter-divs {
        font-size: 12px;
    }
}
@media only screen and (max-width: 340px) {
    .counter-divs {
        font-size: 11px;
    }
}
@media only screen and (max-width: 320px) {
    .counter-divs {
        font-size: 10px;
    }
}
</style>
